import $ from "cash-dom";

//frontend modules
import { ArticlesModule } from './articles';
import { FormModule } from './form';
import { HeaderModule } from './header';
import { ScrollyModule } from './scrolly';
import { SpersonModule } from './sperson';
import { SlideshowModule } from './slideshow';
import { ServicesModule } from './services';
import { KlaroModule } from './klaro';
import { QuotesModule } from './quotes';
import { AnchorScrollModule } from './anchorscroll';

const mods = [
    ArticlesModule,
    FormModule,
    HeaderModule,
    ScrollyModule,
    SpersonModule,
    SlideshowModule,
    ServicesModule,
    KlaroModule,
    QuotesModule,
    AnchorScrollModule,
];


export function initModules($parent) {

    const moditems = [];

    $parent
        .find('[data-module]')
        .each(addModItem);

    if($parent.is('[data-module]')) addModItem.call($parent);

    function addModItem() {
        const modules = $(this).data("module").split(',');
            
        modules.forEach((modname) => {
            moditems.push({
                node: this,
                module: modname.trim()
            });
        });
    }

    moditems.forEach((moditem) => {
        initModule(moditem);
    })
}


function initModule(moditem) {

    const m = mods.filter(el => el.name === moditem.module).shift();
    
    if(m) {
        // console.log('initModule', m.name, moditem.node);
        new m(moditem.node);
    } else {
        console.log('module not found: ', moditem);
    }
}